import AuditScheduleForm from 'src/components/schedule/AuditScheduleForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box } from '@cloudscape-design/components';
import { AuditSchedule } from 'src/types/helios/AuditSchedule';
import { useBaseHook } from 'src/hooks/useBaseHook';

const SchedulesDetailsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const basehook = useBaseHook();
  const schedule: AuditSchedule = location.state?.schedule;
  const templateId: string = location.state?.templateId;
  const copyFromSchedule = location.state?.copyFromSchedule;

  return (
    <Box margin={{ top: 's' }}>
      <AuditScheduleForm
        auditSchedule={schedule}
        templateId={templateId}
        copyFromSchedule={copyFromSchedule}
        onCancel={() => {
          navigate(-1);
        }}
      />
    </Box>
  );
};

export default SchedulesDetailsPage;
